import API from './config'

export const InstitutionRatesAPI = {

    /**
     * Lista todas as taxas de instituições vinculadas a um cliente (vigentes)
     * @param {number} clientId
     * @param {string} [referenceDate] - Data de referência (DD/MM/YYYY) para vigência histórica (R3)
     */
    async getByClient(clientId, referenceDate) {
        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {
            let url = `/institution-rates/client/${clientId}`;
            if (referenceDate) {
                url += `?referenceDate=${encodeURIComponent(referenceDate)}`;
            }
            const response = await API.get(url, config);
            return {
                success: true,
                body: response.data
            };
        } catch (error) {
            return {
                success: false,
                body: error.response ? error.response.data : error
            };
        }
    },

    /**
     * Busca o histórico de taxas de uma instituição vinculada a um cliente
     */
    async getHistory(clientId, instituitionId) {
        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {
            const response = await API.get(`/institution-rates/client/${clientId}/instituition/${instituitionId}/history`, config);
            return {
                success: true,
                body: response.data
            };
        } catch (error) {
            return {
                success: false,
                body: error.response ? error.response.data : error
            };
        }
    },

    /**
     * Cria uma nova taxa para uma instituição vinculada ao cliente
     * (sobrepõe a taxa vigente anterior, mantendo-a no histórico)
     */
    async create(data) {
        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {
            const response = await API.post('/institution-rates', data, config);
            return {
                success: true,
                body: response.data
            };
        } catch (error) {
            return {
                success: false,
                body: error.response ? error.response.data : error
            };
        }
    },

    /**
     * Remove vínculo de uma instituição com o cliente (soft delete / inativa)
     */
    async remove(id) {
        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {
            const response = await API.delete(`/institution-rates/${id}`, config);
            return {
                success: true,
                body: response.data
            };
        } catch (error) {
            return {
                success: false,
                body: error.response ? error.response.data : error
            };
        }
    },
};